import { jsx } from 'react/jsx-runtime';
import React from 'react';

function getMatches(delimiters, m) {
    return function(_, groupIndex) {
        if (groupIndex != null && groupIndex !== 0 && groupIndex % 2 === 0) {
            delimiters.push({
                full: m[groupIndex - 2],
                text: m[groupIndex - 1],
                replacement: m[groupIndex]
            });
        }
    };
}
function basicReactInterpolation(str, interpolationFunction, options) {
    var regex = /\[([^\]]+)\]\(([^)]+)\)/gm;
    var delimiters = [];
    var stringBeforeParse = str;
    var m = regex.exec(str);
    while(m != null){
        if (m.index === regex.lastIndex) {
            regex.lastIndex += 1;
        }
        m.forEach(getMatches(delimiters, m));
        m = regex.exec(str);
    }
    delimiters.forEach(function(param) {
        var full = param.full;
        stringBeforeParse = stringBeforeParse.replace(full, "&&&&".concat(full, "&&&&"));
    });
    var JSXArray = stringBeforeParse.split("&&&&");
    delimiters.forEach(function(param) {
        var full = param.full, replacement = param.replacement, text = param.text;
        JSXArray[JSXArray.indexOf(full)] = interpolationFunction(replacement, text);
    });
    return JSXArray.map(function(item, index) {
        if (/*#__PURE__*/ React.isValidElement(item)) {
            return /*#__PURE__*/ React.cloneElement(item, {
                key: index
            });
        } else if ((options === null || options === void 0 ? void 0 : options.dangerous) && typeof item === "string") {
            return /*#__PURE__*/ jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: item
                }
            }, index);
        } else {
            return item;
        }
    });
}
function customInterpolation(str, interpolations, options) {
    return basicReactInterpolation(str, function(replacement, text) {
        var _interpolations_replacement;
        var _interpolations_replacement1;
        return (_interpolations_replacement1 = (_interpolations_replacement = interpolations[replacement]) === null || _interpolations_replacement === void 0 ? void 0 : _interpolations_replacement.call(interpolations, text)) !== null && _interpolations_replacement1 !== void 0 ? _interpolations_replacement1 : null;
    }, options);
}

export { customInterpolation };
